var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShop = function SvgShop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.5 21.4a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M17.5 21.4a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M5.5 8.4h15.038a1 1 0 0 1 .932 1.362l-2.722 7a1 1 0 0 1-.932.638H10.15a1 1 0 0 1-.914-.594z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.75,
    d: "M1.607 4.55h2.896c.361 0 5.393 11.5 5.393 11.5"
  })));
};
export default SvgShop;